import { useEffect, useRef, useState } from 'react';
import React from 'react';
import './CentumSelect.css';

interface ISelect {
    options: string[] | number[];
    value?: string | number;
    width?: number;
    disabled?: boolean;
    height?: number;
    onChange: (value: string | number) => void;
}

function CentumSelect(props: ISelect) {
    const { options, value = '', width = 130, height = 20, onChange, disabled = false } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState<string | number | null>(value);
    const selectRef = useRef<HTMLDivElement>(null);

    const handleOptionClick = (option: string | number) => {
        if (disabled) return;
        setSelectedOption(option);
        setIsOpen(false);
        onChange(option);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (selectRef.current && !selectRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div
            ref={selectRef}
            className={`CentumSelect ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
            style={{ width: `${width}px`, height: `${height}px` }}>
            <div
                className="selectedOption"
                onClick={() => !disabled && setIsOpen(!isOpen)}
                style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
                <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {selectedOption || options[0]}
                </div>
                <button
                    className="down-scroll-button"
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                    disabled={disabled}>
                    <svg width="6" height="6" viewBox="0 0 6 6">
                        <polygon points="0,0 3,6 6,0" fill={disabled ? '#808080' : 'black'} />
                    </svg>
                </button>
            </div>
            {isOpen && (
                <ul className="optionsList">
                    {options.map((option, index) => (
                        <li key={index} onClick={() => handleOptionClick(option)}>
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default CentumSelect;
